export interface Step {
  number: string
  title: string
  body: string
  image: string
  alt: string
}

export const steps: Step[] = [
  {
    number: '01',
    title: 'Elige tu plantilla',
    body: 'Coloca la plantilla dentro de la esfera y utiliza el diseño como guía.',
    image: 'https://cdn.magicpatterns.com/uploads/3X71ATaUQ1UHDADmhzpFcQ/paso_1.jpg',
    alt: 'Esfera transparente abierta con una plantilla colocada dentro',
  },
  {
    number: '02',
    title: 'Pinta y decora',
    body: 'Aplica colores y detalles con técnicas simples siguiendo el paso a paso.',
    image: 'https://cdn.magicpatterns.com/uploads/wmvfdL6G5ncHcJKC4ASnpo/paso_2.jpg',
    alt: 'Manos pintando una esfera navideña con pinturas acrílicas',
  },
  {
    number: '03',
    title: 'Disfruta tu creación',
    body: 'Disfruta una creación única hecha por ti.',
    image: 'https://cdn.magicpatterns.com/uploads/2qBwgdDkB47Abkk4undb1c/paso_3.jpg',
    alt: 'Esferas navideñas terminadas decorando un árbol de Navidad',
  },
]
